import type { AttachmentFile, DbAttachment } from './types'

export const mapAttachmentsToFiles = (attachments?: DbAttachment[]): AttachmentFile[] => {
  return (attachments ?? []).map(att => ({
    key: att.name,
    name: att.name,
    ufsUrl: att.url,
    url: att.url,
    appUrl: att.url,
    fileHash: att.name,
    serverData: { result: att.url },
    type: 'file',
    size: 0,
    lastModified: Date.now(),
    customId: null
  }))
}
